import { create } from 'zustand'

type State = {
  isOpen: boolean
  returnValue?: string
  open: () => void
  close: () => void
  setReturnValue: (returnValue: string | undefined) => void
}

export const useModal = create<State>((set) => ({
  isOpen: false,
  returnValue: undefined,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setReturnValue: (returnValue: string | undefined) => set({ returnValue }),
}))
